import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientList = createAsyncThunk("client/getClients", async ({ page = 1, filters = {} }, thunkAPI) => {
  try {
    const queryParams = new URLSearchParams({
        page,
        limit: 10,
        ...filters,
      });
    // const token = localStorage.getItem("access_token");
    const res = await axios.get(`${BACKEND_URL}/client/list?${queryParams.toString()}`);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch clients");
  }
});

const clientListingSlice = createSlice({
  name: "clientListing",
    initialState: {
      clients: [],
      pagination: {},
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getClientList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientList.fulfilled, (state, action) => {
            state.clients = action.payload.data;
            state.pagination = {
                current_page: action.payload.current_page,
                last_page: action.payload.last_page,
                total: action.payload.total,
            };
            state.loading = false;
        })
        .addCase(getClientList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch clients"; 
            state.loading = false;
        })
    },
});

export default clientListingSlice.reducer;